<template>
  <v-card flat>
    <v-card-text>
      <v-flex xs12>
        <form-generator
          key="variable render"
          :schema="getSchemaFromStack(taskVariables)"
          :readonly="true"
        />
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'StateVariableRenderer',
  props: {
    taskVariables: Object
  },
  components: {
    FormGenerator: () => import('./FormGenerator')
  },
  methods: {
    getFormType(variable) {
      //  STRING, NUMBER, BOOLEAN, OBJECT, DATE, FILE, ARRAY - possible input options
      if (_.isArray(variable.value)) {
        return 'array'
      } else if (_.isString(variable.value)) {
        switch (variable.type) {
          case 'STRING':
            return 'text'
          case 'NUMBER':
            return 'text'
          case 'BOOLEAN':
            return 'checkbox'
          case 'DATE':
            return 'date'
          case 'FILE':
            return 'file'
          default:
            return 'text'
        }
      } else if (_.isDate(variable.value)) {
        return 'date'
      } else if (_.isNumber(variable.value)) {
        return 'text'
      } else if (_.isBoolean(variable.value)) {
        return 'checkbox'
      } else if (_.isUndefined(variable.value)) {
        return 'text'
      } else if (_.isNull(variable.value)) {
        return 'text'
      } else if (_.isObject(variable.value)) {
        return 'object'
      }
    },
    getSchemaFromStack(obj) {
      let schema = []
      for (let [key, value] of Object.entries(obj)) {
        if (value) {
          schema.push({
            key: key,
            type: this.getFormType(value),
            options: {
              label: key,
              value: value.value,
              cssClass: 'mx-1 my-1'
            }
          })
        }
      }
      return schema
    }
  }
}
</script>

<style scoped></style>
